import React from 'react';
import { cn } from '@/lib/utils';

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        `flex h-11 w-full rounded-xl border border-input bg-background
         px-4 py-2.5 text-sm font-medium ring-offset-background
         file:border-0 file:bg-transparent file:text-sm file:font-medium
         placeholder:text-muted-foreground/70
         transition-all duration-200
         focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/50
         focus-visible:ring-offset-1 focus-visible:border-primary/60
         hover:border-border/80
         disabled:cursor-not-allowed disabled:opacity-50`,
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
Input.displayName = 'Input';

export { Input };
